interface IChainConfig {
    chainId: string;
    chainName: string;
    nativeCurrency: {
        name: string;
        symbol: string;
        decimals: number;
    };
    rpcUrls: string[];
    blockExplorerUrls: string[];
}
export const addchain = async (chainConfig: IChainConfig) => {
    if (!window?.ethereum) {
        return alert('error: not find ethereum')
    }
    try {
        await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: chainConfig.chainId }],
        });
        return true
    } catch (switchError: any) {
        console.log(JSON.stringify(switchError))
        // if (switchError?.code === 4902 || switchError?.code === -32603) {
        // try {
        //     await window?.ethereum?.request({
        //         id: 1, jsonrpc: "2.0", method: 'wallet_addEthereumChain', params: [
        //             chainConfig
        //         ]
        //     })
        //     return true
        // } catch (error) {
        //     // alert(JSON.stringify(error))
        //     return false
        // }
    }
}